
import { orderStatusBySeller } from '@/enum/localEnum'

export default {
    data() {
        return {
            ruleForm: {
                status: null,
                date: null
            }, // 查询数据
            options: [
                { label: '全部', value: null },
                { label: '上架', value: 'ON_STAND' },
                { label: '自行下架', value: 'ONESELF_DOWN_STAND' }
            ], // 查询下拉数据
            priceForm: {
                listData: []
            }, // 列表数据源
            loading: false, // 下滑加载loading
            dialogKanVisible: false, // 弹窗状态
            dialogKanVisible1: false, // 弹窗状态
            dialogTitle: '', // 批量or全部状态
            pageInfo: {
                page: 1,
                pageSize: 10,
                total: 0
            }, // 分页参数
            isChecked: false, // 全选状态
            directStatus: false, //直接改价
            goodsPriceModifyList: [], //统计选择数量
            priceOperation: '', // 弹窗操作状态
            submitData: {
                priceOperation: '',
                ratioPrice: ''
            }, //
            tipInfoData: null, // 弹窗提示
            isCheckedShow: true
        }
    },
    computed: {
        noMore() {
            // 加载到最大值时停止
            return this.priceForm.listData.length >= this.pageInfo.total
        },
        disabled() {
            return this.loading || this.noMore
        }
    },
    methods: {
        validatePrice(rule, value, callback) {
            if (!value) {
                console.log(rule, value)
                callback(new Error('请输入价格'))
            } else if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value)) {
                callback(new Error('请输入有效价格'))
            } else if (value >= 99999999) {
                callback(new Error('超过最大金额'))
            } else {
                callback()
            }
        },
        // 滚动加载
        load() {
            this.loading = true
            setTimeout(() => {
                this.pageInfo.page++
                this.getSellerCenter()
            }, 1000)
        },
        // 筛选查询
        chageList() {
            this.priceForm.listData = []
            this.pageInfo = {
                page: 1,
                pageSize: 10,
                total: 0
            }
            this.loading = true
            this.getSellerCenter()
        },
        /**
         * 获取卖家商品列表
         */
        getSellerCenter() {
            let p = {
                action: { status: this.ruleForm.status },
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize
            }
            if (this.ruleForm.date) {
                p.action.onStandTimeStart = this.ruleForm.date[0] + ' 00:00:00'
                p.action.onStandTimeEnd = this.ruleForm.date[1] + ' 23:59:59'
            }
            this.$api.batchPricePageGoods(p).then((res) => {
                this.loading = false
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                res.data.records.map((item) => {
                    item.checked = false
                    if (item.goodsImg) {
                        return (item.goodsImg = item.goodsImg && item.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg'))
                    }
                })
                this.priceForm.listData.push(...res.data.records)
                this.pageInfo.page = res.data.page
                this.pageInfo.total = res.data.total
                console.log(this.priceForm.listData)
            })
        },
        // 全选
        chackAll() {
            this.isChecked = !this.isChecked
            this.priceForm.listData.map((item) => {
                if (this.isChecked) {
                    item.checked = true
                } else {
                    item.checked = false
                }
            })
        },
        // 输入框聚焦时勾选当前
        checkedInput(val, i) {
            this.priceForm.listData.map((item, index) => {
                if (index == i) {
                    item.checked = true
                }
            })
            return
            if (!val) {
                this.$message.error('请输入价格')
                return
            }
            if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(val)) {
                this.$message.error('请输入有效价格')
                return
            }
            if (val >= 99999999) {
                this.$message.error('超过最大金额')
                return
            }
        },
        // 单选
        itemChecked(item) {
            item.checked = !item.checked
            let status = false
            this.priceForm.listData.map((items) => {
                if (!items.checked) {
                    status = true
                }
            })
            if (status) {
                this.isChecked = false
            } else {
                this.isChecked = true
            }
        },
        // 操作切换提交模式
        operate(title) {
            this.dialogTitle = title
            this.directStatus = true
            this.isCheckedShow = false
            if (this.dialogTitle == '批量') {
                this.priceOperation = '批量上浮'
                this.isCheckedShow = true
            } else if (this.dialogTitle == '全部') {
                this.priceOperation = '全部上浮'
                this.submitData.ratioPrice = null
                this.goodsPriceModifyList = []
                this.directStatus = false
                this.dialogKanVisible = true
            }
            console.log(this.priceOperation, this.dialogTitle)
        },
        // 确定校验
        listSubmitCheck(formName) {
            this.submitData.ratioPrice = null
            this.goodsPriceModifyList = []
            this.priceForm.listData.map((item) => {
                if (item.checked) {
                    this.goodsPriceModifyList.push({
                        goodsNo: item.goodsNo,
                        price: item.price
                    })
                }
            })
            if (this.goodsPriceModifyList.length <= 0 && this.dialogTitle != '全部') {
                this.$message.error('未选中所需修改的商品')
                return
            }
            if (this.dialogTitle == '直接') {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.dialogKanVisible1 = true
                    } else {
                        return false
                    }
                })
            } else if (this.dialogTitle == '批量') {
                this.dialogKanVisible = true
            } else if (this.dialogTitle == '全部') {
                this.dialogKanVisible = true
            }
        },
        // 确认改价前校验
        confirmSubmit() {
            if (this.priceOperation == '批量上浮' || this.priceOperation == '批量下调' || this.priceOperation == '全部上浮' || this.priceOperation == '全部下调') {
                if (!this.submitData.ratioPrice) {
                    this.$message.error('请输入调整的百分比')
                    return
                }
                if (!Number.isInteger(Number(this.submitData.ratioPrice))) {
                    this.$message.error('请输入整数')
                    return
                }
                if (this.submitData.ratioPrice >= 100) {
                    this.$message.error('超过最大100%')
                    return
                }
                this.dialogKanVisible1 = true
            } else {
                if (!this.submitData.ratioPrice) {
                    this.$message.error('请输入价格')
                    return
                }
                if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(this.submitData.ratioPrice)) {
                    this.$message.error('请输入有效价格')
                    return
                }
                if (this.submitData.ratioPrice >= 99999999) {
                    this.$message.error('超过最大金额')
                    return
                }
                this.dialogKanVisible1 = true
            }
        },
        // 提交
        submit() {
            if (this.dialogTitle == '直接') {
                let data = {
                    action: {
                        goodsPriceModifyList: this.goodsPriceModifyList
                    }
                }
                this.$api.goodsModifyPrice(data).then((res) => {
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.clearChecked()
                    this.dialogKanVisible1 = false
                    this.directStatus = false
                    this.isChecked = false
                    this.isCheckedShow = true
                    this.$message.success('改价任务提交成功，请30分钟后再来查看')
                })
            } else if (this.dialogTitle == '批量') {
                switch (this.priceOperation) {
                    case '批量上浮':
                        this.submitData.priceOperation = 'UP_RATIO'
                        break
                    case '批量加价':
                        this.submitData.priceOperation = 'UP_PRICE'
                        break
                    case '批量下调':
                        this.submitData.priceOperation = 'DOWN_RATIO'
                        break
                    case '批量减价':
                        this.submitData.priceOperation = 'DOWN_PRICE'
                        break
                }
                let data = {
                    action: {
                        goodsPriceModifyList: this.goodsPriceModifyList,
                        priceOperation: this.submitData.priceOperation,
                        ratioPrice: this.submitData.ratioPrice
                    }
                }
                this.$api.goodsBatchModifyPrice(data).then((res) => {
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.clearChecked()
                    this.dialogKanVisible = false
                    this.dialogKanVisible1 = false
                    this.directStatus = false
                    this.isChecked = false
                    this.isCheckedShow = true
                    this.$message.success('改价任务提交成功，请30分钟后再来查看')
                })
            } else if (this.dialogTitle == '全部') {
                switch (this.priceOperation) {
                    case '全部上浮':
                        this.submitData.priceOperation = 'UP_RATIO'
                        break
                    case '全部加价':
                        this.submitData.priceOperation = 'UP_PRICE'
                        break
                    case '全部下调':
                        this.submitData.priceOperation = 'DOWN_RATIO'
                        break
                    case '全部减价':
                        this.submitData.priceOperation = 'DOWN_PRICE'
                        break
                }
                let data = {
                    action: {
                        queryAction: {},
                        priceOperation: this.submitData.priceOperation,
                        ratioPrice: this.submitData.ratioPrice
                    }
                }
                if (this.ruleForm.date) {
                    data.action.queryAction.onStandTimeStart = this.ruleForm.date[0] + ' 00:00:00'
                    data.action.queryAction.onStandTimeEnd = this.ruleForm.date[1] + ' 23:59:59'
                }
                if (this.ruleForm.status) {
                    data.action.queryAction.status = this.ruleForm.status
                }
                this.$api.goodsAllModifyPrice(data).then((res) => {
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.clearChecked()
                    this.dialogKanVisible = false
                    this.dialogKanVisible1 = false
                    this.directStatus = false
                    this.isChecked = false
                    this.isCheckedShow = true
                    this.$message.success('改价任务提交成功，请30分钟后再来查看')
                })
            }
        },
        // 重置选中状态
        clearChecked() {
            this.priceForm.listData.map((item) => {
                item.checked = false
            })
        },
        // 获取批量改价提示语
        getTipInfo() {
            let _gj = {
                action: {
                    id: 38
                }
            }
            this.$api.getHagglingDetail(_gj).then((_res) => {
                if (_res.success) {
                    this.tipInfoData = _res.data.content
                } else {
                    this.$message.error(_res.info)
                }
            })
        },
        // 取消操作
        closeOperation() {
            this.directStatus = false
            this.isCheckedShow = true
            this.isChecked = false
            this.dialogTitle = ''
            this.priceForm.listData = []
            this.pageInfo = {
                page: 1,
                pageSize: 10,
                total: 0
            }
            this.loading = true
            let p = {
                action: { status: this.ruleForm.status },
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize
            }
            if (this.ruleForm.date) {
                p.action.onStandTimeStart = this.ruleForm.date[0] + ' 00:00:00'
                p.action.onStandTimeEnd = this.ruleForm.date[1] + ' 23:59:59'
            }
            this.$api.batchPricePageGoods(p).then((res) => {
                this.loading = false
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                res.data.records.map((item) => {
                    item.checked = false
                    if (item.goodsImg) {
                        return (item.goodsImg = item.goodsImg && item.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg'))
                    }
                })
                this.priceForm.listData = res.data.records
                this.pageInfo.page = res.data.page
                this.pageInfo.total = res.data.total
            })
        }
    },
    mounted() {
        this.getSellerCenter()
        this.getTipInfo()
    }
}
